import { z } from 'zod';
import { UserSchema, UserTypeSchema, UserClassificationSchema, refineExternalMember } from '../../entities/user/user.schema';
import { ErrorCode } from '../../shared/error-codes';
import { SupportedLanguageSchema } from '../../shared/language.schema';
/**
 * Add Org Member Request Schema
 * POST /api/v2/org-members
 */ export const AddOrgMemberRequestSchema = z.object({
    firstName: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    lastName: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    email: z.string().email(ErrorCode.FIELD_INVALID_EMAIL),
    department: z.string().optional(),
    mainRole: z.string().optional(),
    secondaryRoles: z.array(z.string()).optional(),
    location: z.string().trim().min(1).optional(),
    userTypes: z.array(UserTypeSchema),
    sendInvitation: z.boolean().optional(),
    classification: UserClassificationSchema,
    externalOrganization: z.string().optional(),
    language: SupportedLanguageSchema.optional()
}).superRefine((data, ctx)=>{
    // Require department when classification is 'internal'
    if (data.classification === 'internal' && !data.department) {
        ctx.addIssue({
            code: 'custom',
            message: ErrorCode.FIELD_REQUIRED,
            path: [
                'department'
            ]
        });
    }
    // Disallow department when classification is 'external'
    if (data.classification === 'external' && data.department) {
        ctx.addIssue({
            code: 'custom',
            message: ErrorCode.EXTERNAL_MEMBER_NO_DEPARTMENT,
            path: [
                'department'
            ]
        });
    }
    // External members: externalOrganization + elevated role required.
    refineExternalMember(ctx, data);
});
/**
 * Add Org Member Response Schema
 * POST /api/v2/org-members
 */ export const AddOrgMemberResponseSchema = z.object({
    data: UserSchema
});

//# sourceMappingURL=add-org-member.schema.js.map